import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { GET_CONDITION } from '../../Store/AssetManagement/Condition/ConditionType'
import { setCondition } from 'Store/AssetManagement/Condition/ConditionAction';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';


function* getCondition() : any {
    let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/conditions`,
        payload : null
    }

    try {
        yield put(globalLoaderText("Fetching Condition...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if(response?.length > 0){
        const defaultConditionOption = {
            text: "Select Condition",
            value: null
        };
        response.unshift(defaultConditionOption);
       }
        yield put(setCondition(response))

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setCondition([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetCondition() {
    yield takeEvery(GET_CONDITION, getCondition)
}

export default function* combinedSaga() {
    yield all([
        watchGetCondition()
    ])
}
